import { render, staticRenderFns } from "./UserWatermark.vue?vue&type=template&id=20df99a6&scoped=true"
import script from "./UserWatermark.vue?vue&type=script&lang=js"
export * from "./UserWatermark.vue?vue&type=script&lang=js"
import style0 from "./UserWatermark.vue?vue&type=style&index=0&id=20df99a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20df99a6",
  null
  
)

export default component.exports